import { Pipe, PipeTransform } from '@angular/core';

const WORDS_SPLITTER_REGEX: RegExp = /(?=[' (|-])/g;

@Pipe({
    name: 'capitalize',
    standalone: false,
})
export class CapitalizePipe implements PipeTransform {
    public transform(value: string | undefined, defaultValue?: string): string {
        const trimmedLoweredValue: string | undefined = value?.trim().toLowerCase();

        if (!trimmedLoweredValue) {
            return defaultValue || '';
        }

        return trimmedLoweredValue.split(WORDS_SPLITTER_REGEX).map(this.capitalize).join('');
    }

    private capitalize = (x: string): string => {
        if (x.indexOf('-') + x.indexOf('\'') > -2 || x.startsWith(' ') || x.startsWith('(')) {
            return x.slice(0, 2).toUpperCase() + x.slice(2);
        }

        return x.slice(0, 1).toUpperCase() + x.slice(1);
    };
}
